import request from '@/apis/request'
const resource = 'credits' 

export default {  
  get: (params = {}) => {
    return request.get(`${resource}`,{ params })
  }, 

  topup: (data) => { 
    return request.post(`${resource}`,data)
  },

  withdraw: (data) => { 
    return request.post(`${resource}/withdraw`,data)
  },

  confirm: (uid,data) => {
    return request.put(`${resource}/${uid}`,data)
  },

  confirmFormData: (uid,data) => {

    const options = {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    }

    return request.put(`${resource}/${uid}`,data,options)
  },

  cancel: (uid) => { 
    return request.delete(`${resource}/${uid}`)
  },

  withdrawCommission: (data) => { 
    return request.post(`${resource}/transfer-commissions`,data)
  },

  withdrawCashback: (data) => { 
    return request.post(`${resource}/transfer-cashback`,data)
  },
}